function Footer() {
    try {
        return (
            <footer className="bg-white border-t-2 border-black py-8" data-name="footer">
                <div className="container mx-auto px-4">
                    <div className="text-center text-sm text-gray-600" data-name="footer-copyright">
                        © {new Date().getFullYear()} TanAI
                    </div>
                </div>
            </footer>
        );
    } catch (error) {
        console.error('Footer component error:', error);
        reportError(error);
        return null;
    }
}

export default Footer;